import React from "react";

class MyList extends React.Component {
    render() {
        return (
            <div>
                <h1>MyList</h1>
            </div>
        );
    }
}

export default MyList;
